import { ActivitiesEntryTypeEnum } from "redmond";
import queryStringParser from "query-string";
import { parseEntryTypes } from "../../shop/sagas/fetchExperiencesShopSaga";

export const resolveEntryTypesFromQueryString = (params: {
  search: string;
  existingEntryType: ActivitiesEntryTypeEnum | undefined;
  existingEntryTypesAll: ActivitiesEntryTypeEnum[] | undefined;
}): {
  entryType: ActivitiesEntryTypeEnum;
  entryTypesAll: ActivitiesEntryTypeEnum[];
} | null => {
  const { search, existingEntryType, existingEntryTypesAll } = params;

  // Shop already ran fetchExperiencesShopSaga's own parsing this session — don't clobber it.
  if (
    existingEntryType ||
    (existingEntryTypesAll && existingEntryTypesAll.length > 0)
  ) {
    return null;
  }

  const { entryType } = queryStringParser.parse(search);
  const entryTypesAll = parseEntryTypes(entryType);
  if (entryTypesAll.length === 0) return null;

  return {
    entryType: entryTypesAll[entryTypesAll.length - 1],
    entryTypesAll,
  };
};
